import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DataIntegration } from "~/components/feature/data-integration";

const dataIntegrationSearchSchema = z.object({
  tab: z.enum(["initial", "monthly"]).optional(),
});

export const Route = createFileRoute("/_app/data/integration")({
  component: RouteComponent,
  validateSearch: dataIntegrationSearchSchema,
});

function RouteComponent() {
  return <DataIntegration />;
}
